<template>
  <div class="continer">
    <ul>
      <li>
        <h4>一、中心资质</h4>
        <p>
          通辽市建设工程施工图审查中心前身为通辽大有建设工程施工图审查有限公司，
          公司于二零一三年改制更名为审图中心，
          并于二零一四年经内蒙古自治区建设厅确定升级为一类施工图审查机构。
        </p>
      </li>
      <li>
        <h4>二、人员构成</h4>
        <p>
          通辽市建设工程施工图审查中心现有员工26人， 
          其中：高级职称15人、中级职称7人、初级职称2人、行政2人。 
          审查人员现有国家一级注册建筑师3人、国家一级注册结构师4人、
          注册设备师3人、注册电气师1人。   
        </p>
      </li>
      <li>
        <h4>三、机构设置</h4>
        <p>中心实行主任负责制</p>
        <p>下设:总工程师及总工程师办公室;</p>
        <p>行政办公室;</p>
        <p>建筑专业审查室(含市政审查);</p>
        <p>结构专业审查室(含地勘审查);</p>
        <p>设备专业审查室(给排水,供热通风,电气)。</p>
      </li>
      <li>
        <h4>四、业务范围</h4>
        <p>
           承担房屋建设,市政基础设施建设施工图审查,
           并在通辽市住建委领导下,开展各项专家技术论证及技术咨询。公司各专业配套齐全,
           能满足各类房屋建筑及市政基础设施施工图的审查要求。
        </p>
      </li>
      <li>
        <h4>五、服务宗旨</h4>
        <p>
           公正&nbsp;求实&nbsp;博学&nbsp;严谨
        </p>
      </li>
      <li>
        <h4>六、提高设计、审图质量</h4>
        <p>
           为进一步提高设计及审图质量，公司经市住建委同意，
           成立了有资深专业人员组成的顾问委员会，并已聘请了第一批专家委员，
           顾问委员会的专家来自于各勘察设计单位，目的是：
        </p>
        <p>
          1、 通过施工图审查，与设计单位及勘察单位建立一个沟通的平台。
        </p>
        <p>
          2、 通过这个平台，将沟通传达到每一个结点，可以使审查人员及勘察设计人员及时进行沟通、交流。
        </p>
        <p>
          3、 通过沟通交流，使设计、审查的业务水平相互促进，相互提高。
        </p>
      </li>
      <li>
        <p>
          中心竭诚欢迎上级主管部门及新老客户光临指导！
        </p>
      </li>
      <li>
        <p>
          通辽市建设工程施工图审查中心
        </p>
      </li>
    </ul>
  </div>
</template>
<script>
export default {

}
</script>
<style lang="stylus" scoped>
.continer 
  width 100%
  color #333
  li 
    margin-bottom 50px
    h4 
      font-size 14px
      line-height 30px
    p 
      font-size 12px
      text-indent 2em
      line-height 30px
</style>
